import { Environment } from './env'

export const { MODE, VITE_SUPABASE_ANON_KEY, VITE_SUPABASE_URL, VITE_GOOGLE_CLIENT_ID } = Environment.config(
  import.meta.env
)
